import i18n from 'i18next'
import listLng from './resources/listLng.json'
import resources from './resources/translation.json'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  resources,
  lng: listLng[0],
  fallbackLng: listLng[0],
})

export default i18n
